import React from "react";

export default function Navbar({ date }) {
  return (
   
      <div className="date-box mx-auto shadow-sm">{date}</div>
   
  );
}
